import { render, staticRenderFns } from "./ProjektInfos.vue?vue&type=template&id=fa0d1f78&"
import script from "./ProjektInfos.vue?vue&type=script&lang=js&"
export * from "./ProjektInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProjektInfos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports